import { useState } from 'react';

import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { IconAngleRight, IconCalendar } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { RCFRepaymentSchedule } from './RCFRepaymentSchedule/RCFRepaymentSchedule';
import { isSelectedAmountValid } from '../../../ui/ChooseAmountInputWithSlider/isSelectedAmountValid';

export const ViewPaymentPlan = ({
    drawdownAmount,
    offer
}: {
    drawdownAmount: number;
    offer: TFormalOffer;
}) => {
    const [showPaymentPlan, setShowPaymentPlan] = useState(false);
    const { data } = useDrawdownRepaymentSchedule({
        offerId: offer.offer_id!,
        drawdownAmount,
        enabled: isSelectedAmountValid(drawdownAmount, offer),
        suspense: true
    });

    const repaymentSchedule = data!;

    return (
        <>
            <Modal
                isOpen={showPaymentPlan}
                onClose={() => setShowPaymentPlan(false)}
                closeIcon
            >
                <RCFRepaymentSchedule
                    newOutstandingBalance={drawdownAmount}
                    repaymentSchedule={repaymentSchedule}
                />
            </Modal>

            <Button
                variant="tertiary"
                className="px-0"
                onClick={() => setShowPaymentPlan(true)}
            >
                <IconCalendar />
                <FormattedMessage
                    id="_.rcf_approved_view.offer_details_view_payment_plan"
                    defaultMessage="View payment plan"
                />
                <IconAngleRight />
            </Button>
        </>
    );
};
